/**
 * @author  ( Angle180 LLC  )
 * @copyright Copyright (C) 2014 Angle180 LLC. All rights reserved.
 * @license Commercial Template. Do not use without written permission on Angle180 LLC.
 */

// "use strict";

// const preloader = new Array(
// )

// Document Ready state
// preload images 
// do stuff while page is not renderd
// document.onready = function() {
//     //Preload images
//     if (preloader.length > 0) {
//         preload(preloader)
//     }
// }

// Window Read state
// Page is rendered now can display
// some elements!
window.onload = function() {
    // backToTop();
    smoothScroll();
    adjustHeight();
    search();
    // jQuery(".menu-item-has-children > a").doubleTapToGo();
};

//Window Resize action
window.onresize = function() {
    adjustHeight();
};


/*
 * Functions:
 * - preload(preloader) => Preload images in array of preload variable
 */

// function preload(images) {
//     const img = new Array();
//     for (let x=0; x<=(images.length-1); x++) {
//         img[x] = new Image()
//         img[x].src=images[x]
//     }
// }